import { toBase64 } from '../../../../utils/index.js';
import { BaseWasmQuery } from '../../BaseWasmQuery.js';
export class QueryResolverAddress extends BaseWasmQuery {
    toPayload() {
        return toBase64({
            resolver: {
                node: this.params.node,
            },
        });
    }
}
